import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch, type RootState} from '../../../store/store';
import {clearDialerNavigation, setDialerHidden} from '../../../store/features/calls/dialerSlice';
import {promptDndCall, setDialerNotice, type DialerNotice} from '../store/callSurfaceSlice';

const NOTICES: Readonly<Record<string, DialerNotice>> = {
    '/error/in-call': 'in_call',
    '/error/sip-error': 'sip_error',
    '/error/no-number': 'no_number',
};

export const useDialerRouting = (): void => {
    const dispatch = useAppDispatch();
    const navigateTo = useSelector((state: RootState) => state.dialer.navigateTo);

    useEffect(() => {
        if (!navigateTo || typeof navigateTo !== 'string') {
            return;
        }
        dispatch(clearDialerNavigation());
        if (navigateTo === '/dnd-call') {
            dispatch(setDialerHidden(true));
            dispatch(promptDndCall());
            return;
        }
        if (navigateTo === '/') {
            dispatch(setDialerNotice(undefined));
            return;
        }
        const notice = NOTICES[navigateTo];
        if (notice) {
            dispatch(setDialerNotice(notice));
            if (notice === 'no_number') {
                dispatch(setDialerHidden(false));
            }
        }
    }, [dispatch, navigateTo]);
};
